export const PAGE_WRAPPER_STYLES = 'max-w-full w-[1000px] mx-12 self-center';
